// extracted by mini-css-extract-plugin
export var avatar = "_mj-3";
export var avatarContainer = "_mj-2";
export var avatarSpacer = "_mj-5";
export var avatarSpacerContainer = "_mj-4";
export var avatarStackContainer = "_mj-1";
export var bubble = "_mj-0";
export var remainderBubble = "_mj-6";